export { RatingComponent } from './rating.component';
export { RatingModule } from './rating.module';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-bootstrap/rating/index.js
// module id = 1024
// module chunks = 33